(() => {
  'use strict';
  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-menu-toggle]');
    if (toggle) {
      const nav = document.getElementById(toggle.getAttribute('aria-controls'));
      const open = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? 'Cerrar menú' : 'Abrir menú');
      nav?.classList.toggle('is-open', open);
    }
    const direction = event.target.closest('[data-slide-prev], [data-slide-next]');
    if (direction) {
      const track = direction.closest('[data-slider]').querySelector('[data-track]');
      track.scrollBy({left:track.clientWidth * (direction.hasAttribute('data-slide-next') ? 1 : -1),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    }
    document.querySelectorAll('.nav-dropdown[open]').forEach(menu => {
      if (!menu.contains(event.target)) menu.removeAttribute('open');
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.nav-dropdown[open]').forEach(menu => {
      menu.removeAttribute('open');
      menu.querySelector('summary')?.focus();
    });
    const toggle=document.querySelector('[data-menu-toggle][aria-expanded="true"]');
    if(toggle){toggle.click();toggle.focus();}
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-sort]')) event.target.form.requestSubmit();
    if (!event.target.matches('[data-variant-select]')) return;
    const select=event.target, option=select.selectedOptions[0], section=select.closest('[data-product-section]');
    section.querySelector('[data-price]').textContent=option.dataset.price;
    const compare=section.querySelector('[data-compare]');
    compare.textContent=option.dataset.compare;compare.hidden=!option.dataset.compare;
    const available=option.dataset.available === 'true';
    section.querySelector('[data-availability]').textContent=available ? 'Disponible para ordenar' : 'Agotado';
    section.querySelector('[data-sku]').textContent='SKU: '+(option.dataset.sku || '—');
    const submit=section.querySelector('[data-add-button]');
    submit.disabled=!available;submit.textContent=available ? 'Añadir al carrito' : 'Agotado';
    const url=new URL(location.href);url.searchParams.set('variant',select.value);history.replaceState({},'',url);
    const media=section.querySelector('[data-media-id="'+option.dataset.media+'"]');
    if(media) { const gallery = section.querySelector('[data-product-gallery]'); if(gallery) gallery.dispatchEvent(new CustomEvent('product:media',{detail:{id:option.dataset.media}})); else media.parentElement.prepend(media); }
  });
})();

// Progressive enhancement: real horizontal rails, pauseable movement and editor reload support.
(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const instances = new Map();
  function mount(scope = document) {
    scope.querySelectorAll('[data-carousel], [data-slider]').forEach(section => {
      if (instances.has(section)) return;
      const hero = section.matches('[data-slider]');
      const rail = section.querySelector(hero ? '[data-track]' : '[data-rail]');
      if (!rail || (!hero && !rail.classList.contains('product-rail'))) return;
      const auto = section.dataset[hero ? 'heroAuto' : 'autoplay'] === 'true';
      const period = Number(section.dataset[hero ? 'heroInterval' : 'interval']) || 5000;
      const control = section.querySelector(hero ? '[data-hero-pause]' : '[data-rail-pause]');
      let paused = false, hover = false, focused = false, visible = false, timer;
      const step = direction => {
        const first = rail.firstElementChild;
        const stride = hero ? rail.clientWidth : (first?.getBoundingClientRect().width || 230) + (parseFloat(getComputedStyle(rail).columnGap) || 0);
        const end = rail.scrollWidth - rail.clientWidth;
        const next = direction > 0 && rail.scrollLeft >= end - 5 ? 0 : direction < 0 && rail.scrollLeft < 5 ? end : rail.scrollLeft + stride * direction;
        rail.scrollTo({left: next, behavior: reduced.matches ? 'auto' : 'smooth'});
      };
      const refresh = () => {
        clearInterval(timer);
        if (auto && !paused && !hover && !focused && visible && !reduced.matches && !document.hidden && rail.scrollWidth > rail.clientWidth + 5) timer = setInterval(() => step(1), period);
      };
      const prev = section.querySelector('[data-rail-prev]'), next = section.querySelector('[data-rail-next]');
      prev?.addEventListener('click', () => { step(-1); refresh(); });
      next?.addEventListener('click', () => { step(1); refresh(); });
      control?.addEventListener('click', () => { paused = !paused; control.setAttribute('aria-pressed', String(paused)); control.textContent = paused ? 'Reanudar' : 'Pausar'; control.setAttribute('aria-label', paused ? 'Reanudar carrusel' : 'Pausar carrusel'); refresh(); });
      section.addEventListener('mouseenter', () => { hover = true; refresh(); });
      section.addEventListener('mouseleave', () => { hover = false; refresh(); });
      section.addEventListener('focusin', () => { focused = true; refresh(); });
      section.addEventListener('focusout', () => { setTimeout(() => { focused = section.contains(document.activeElement); refresh(); }, 0); });
      rail.addEventListener('touchstart', () => { paused = true; if(control){control.textContent='Reanudar';control.setAttribute('aria-pressed','true');control.setAttribute('aria-label','Reanudar carrusel');} refresh(); }, {passive:true});
      const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; refresh(); }, {threshold:.15});
      observer.observe(section);
      document.addEventListener('visibilitychange', refresh);
      reduced.addEventListener('change', refresh);
      instances.set(section, () => { clearInterval(timer); observer.disconnect(); document.removeEventListener('visibilitychange', refresh); reduced.removeEventListener('change', refresh); });
    });
    scope.querySelectorAll('[data-motion-pause]').forEach(button => {
      if(button.dataset.ready) return;
      button.dataset.ready='true';
      button.addEventListener('click', () => { const paused = button.closest('.motion-strip').classList.toggle('is-paused'); button.setAttribute('aria-pressed',String(paused)); button.textContent=paused?'Reanudar':'Pausar'; });
    });
    scope.querySelectorAll('[data-reveal]').forEach(section => {
      if(reduced.matches || window.Shopify?.designMode){section.classList.add('is-visible');return;}
      const observer=new IntersectionObserver(entries=>{if(entries[0].isIntersecting){section.classList.add('is-visible');observer.disconnect();}},{threshold:.05});observer.observe(section);
    });
  }
  if ('IntersectionObserver' in window) { document.documentElement.classList.add('motion-ready');mount(); }
  document.addEventListener('shopify:section:load',event=>mount(event.target));
  document.addEventListener('shopify:section:unload',event=>{for(const [section,dispose] of instances){if(event.target.contains(section)){dispose();instances.delete(section);}}});
})();

// Native variant IDs remain the source of truth for cart submissions.
(() => {
  function mount(scope = document) {
    scope.querySelectorAll('[data-variant-picker]').forEach(root => {
      if (root.dataset.pickerReady) return;
      const select = root.querySelector('[data-variant-select], [data-card-variant-select]');
      const chips = root.querySelector('[data-variant-chips]');
      if (!select || !chips || !chips.querySelector('button')) return;
      const options = [...select.options].map(option => ({option, values: JSON.parse(option.dataset.values)}));
      const buttons = [...chips.querySelectorAll('[data-option-index]')];
      const card = root.hasAttribute('data-card-picker');
      const initialImage = root.querySelector('.product-image img')?.getAttribute('src');
      function sync() {
        const selected = options.find(item => item.option.value === select.value);
        if (!selected) return;
        buttons.forEach(button => {
          const index = Number(button.dataset.optionIndex), value = button.dataset.optionValue;
          button.setAttribute('aria-pressed', String(selected.values[index] === value));
          const matches = options.filter(item => item.values[index] === value);
          button.classList.toggle('is-unavailable', !matches.some(item => item.option.dataset.available === 'true'));
          button.title = matches.some(item => item.option.dataset.available === 'true') ? value : value + ' — Agotado';
        });
        if (!card) return;
        const data = selected.option.dataset;
        root.querySelector('[data-card-price]').textContent = data.price;
        const compare = root.querySelector('[data-card-compare]');
        compare.textContent = data.compare || ''; compare.hidden = !data.compare;
        root.querySelector('[data-card-saving]').textContent = data.saving || '\u00a0';
        root.querySelector('[data-card-sale]').hidden = !data.compare;
        root.querySelector('[data-card-sold]').hidden = data.available === 'true';
        const add = root.querySelector('[data-card-add]');
        if (add) {add.disabled = data.available !== 'true'; add.textContent = add.disabled ? 'Agotado' : 'Añadir';}
        root.querySelectorAll('[data-product-link]').forEach(link => {
          const url = new URL(link.href); url.searchParams.set('variant', select.value); link.href = url.href;
        });
        const img = root.querySelector('.product-image img');
        if (img && (data.image || initialImage)) {img.src = data.image || initialImage; img.removeAttribute('srcset');}
      }
      chips.addEventListener('click', event => {
        const button = event.target.closest('[data-option-index]');
        if (!button) return;
        const index = Number(button.dataset.optionIndex), value = button.dataset.optionValue;
        const current = options.find(item => item.option.value === select.value);
        const matches = options.filter(item => item.values[index] === value);
        const exact = matches.find(item => item.values.every((v, i) => i === index || v === current.values[i]));
        const next = exact || matches.find(item => item.option.dataset.available === 'true') || matches[0];
        if (!next) return;
        select.value = next.option.value;
        select.dispatchEvent(new Event('change', {bubbles: true}));
      });
      select.addEventListener('change', sync);
      // Multi-option cards retain the complete selector for other options.
      root.querySelector('[data-native-variant]').hidden = !card || options[0].values.length === 1;
      chips.hidden = false; root.dataset.pickerReady = 'true'; sync();
    });
  }
  mount();
  document.addEventListener('shopify:section:load', event => mount(event.target));
})();

// Photo preview and product gallery.
(() => {
  document.addEventListener('click', event => {
    const link = event.target.closest('.product-image--swap');
    document.querySelectorAll('.product-image--swap.is-preview').forEach(other => { if(other !== link) other.classList.remove('is-preview'); });
    if(link && (event.pointerType === 'touch' || matchMedia('(hover: none)').matches) && !link.classList.contains('is-preview')) { event.preventDefault(); link.classList.add('is-preview'); }
  });
  function mount(scope=document) {
    scope.querySelectorAll('[data-product-gallery]').forEach(gallery => {
      if(gallery.dataset.galleryReady) return;
      const items = [...gallery.querySelectorAll('[data-media-id]')], buttons = [...gallery.querySelectorAll('[data-gallery-target]')];
      function select(id) {
        if(!items.some(item => item.dataset.mediaId === String(id))) return;
        items.forEach(item => { const active = item.dataset.mediaId === String(id); item.hidden = !active; if(!active) item.querySelectorAll('video').forEach(video=>video.pause()); });
        buttons.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.galleryTarget===String(id))));
      }
      gallery.addEventListener('click',event=>{const button=event.target.closest('[data-gallery-target]');if(button)select(button.dataset.galleryTarget);});
      gallery.addEventListener('product:media',event=>select(event.detail.id));
      gallery.dataset.galleryReady='true';
    });
  }
  mount(); document.addEventListener('shopify:section:load',event=>mount(event.target));
})();
